import React from "react";

import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import Snackbar from "@mui/material/Snackbar";
import SnackbarContent from "components/snackbars";
import LoginFormEmployee from "components/page/login-form-employee";
import * as auth from "store/actions/auth";
import {requestEmployeeLogin, clearError, STATUS_LOGGING} from "store/actions/auth";
import {addNotice} from "store/actions/notices"

import * as Style from "./style";

class LoginEmployeePage extends React.Component {
    static propTypes = {
        loginStatus: PropTypes.string,
        loginError: PropTypes.bool,
        loginErrorMessage: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            showError: false,
            showForgotPassword: false
        };
    }

    static getDerivedStateFromProps(props) {
        const {loginError} = props;
        if (loginError) {
            return {
                showError: true
            };
        }
        return null;
    }

    componentDidUpdate() {
        if (!this.state.showError && this.props.loginError) {
            this.setState({
                showError: true
            });
        }
    }

    handleCloseError = () => {
        this.props.clearError();
        this.setState({
            showError: false
        });
    }

    handleSubmit = data => {
        this.props.login(data.username, data.password);
    };

    render() {
        const {loginStatus, loginErrorMessage} = this.props;
        const {showPassword} = this.state;
        const errorMessage = (
            <Snackbar
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left"
                }}
                autoHideDuration={6000}
                open={this.state.showError}
                onClose={this.handleCloseError}
            >
                <SnackbarContent variant="error" message={loginErrorMessage} onClose={this.handleCloseError}/>
            </Snackbar>
        );

        return (
            <Style.RoodDiv>
                <Style.FormDiv>
                    <Style.Title>Overside</Style.Title>
                    <Style.Subtitle>Pannello dipendenti</Style.Subtitle>
                    {!showPassword && (
                        <LoginFormEmployee
                            onShowPassword={() => this.setState({showPassword: true})}
                            onSubmit={this.handleSubmit}
                            loading={loginStatus === STATUS_LOGGING}
                        />)
                    }
                    {showPassword}
                </Style.FormDiv>
                {errorMessage}
            </Style.RoodDiv>
        );
    }
}

const mapStateToProps = (state) => {
    const employeeState = state.auth.employee || {}; 
    return {
        loginStatus: employeeState.status || auth.STATUS_NOTLOGGED,
        loginError: employeeState.error || false,
        loginErrorMessage: employeeState.errorMessage || null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        login: bindActionCreators(requestEmployeeLogin, dispatch),
        clearError: bindActionCreators(clearError, dispatch),
        addNotice: bindActionCreators(addNotice,dispatch)
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginEmployeePage);
